//import "./Toggle.css";

const Toggle = ({ handleChange, isChecked, target, labelContent }) => {
  return (
    <div className={target+"-toggle-container"}>
      <input 
        type="checkbox"
        id={target+"-check"}
        className={target+"-toggle-input"}
        onChange={handleChange}
        checked={isChecked}
      />
      <label className={target+"-toggle-label"} htmlFor={target+"-check"}>{labelContent}</label>
    </div>
  );
};
export default Toggle;